<template>
  <div class="chartOfAccount-list">
    <EntityFilter
      :selectedFilter="selectedFilter"
      :filterCriteria="filterCriteria"
      :preFilters="selectedPreFilters"
      @criteriaChange="performSetSelectedFilter"
      @valueChange="loadData"
    />
    <div class="table-container margined bordered">
      <table cellspacing="0" class="table-element">
        <thead>
          <tr class="header">
            <th class="cell"></th>
            <th class="cell">Name</th>
            <th class="cell">Account #</th>
            <th class="cell">Organization Account #</th>
            <th class="cell">Created by</th>
            <th class="cell">Updated by</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-if="
              loadingStatus.getChartOfAccounts && chartOfAccounts.length === 0
            "
            class="row"
          >
            <td colspan="100" class="center padded">
              <i class="fas fa-spin fa-circle-notch"></i> Loading...
            </td>
          </tr>
          <tr class="row" v-for="g in chartOfAccounts" :key="g._id">
            <td class="cell">
              <inline-button
                v-if="!allowSelection"
                :to="{ name: 'chartOfAccountEditor', query: { id: g._id } }"
                icon="Open"
                type="plain-primary responsive-column form-height wide"
              />
              <inline-button
                v-if="allowSelection"
                label="Select"
                type="plain-primary responsive-column form-height wide"
                @click="() => emitSelectedElement(g)"
              />
            </td>
            <td class="cell">{{ g.name }}</td>
            <td class="cell">{{ g.accountNo }}</td>
            <td class="cell">{{ g.accountNoOrganization }}</td>
            <td class="cell">
              {{
                g.createdBy
                  ? g.createdBy.name +
                    " " +
                    (g.createdBy.lastName ? g.createdBy.lastName : "")
                  : "-"
              }}
            </td>
            <td class="cell">
              {{
                g.updatedBy
                  ? g.updatedBy.name +
                    " " +
                    (g.updatedBy.lastName ? g.updatedBy.lastName : "")
                  : "-"
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="false" class="table-paginator-container">
        <div class="table-paginator-page">1</div>
        <div class="table-paginator-page table-paginator-page--selected">2</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EntityFilter from "@/components/EntityFilter/EntityFilter";

export default {
  name: "ChartOfAccountList",
  data() {
    return {};
  },
  props: {
    allowSelection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EntityFilter,
  },
  mounted: function () {
    this.getChartOfAccounts();
  },
  computed: {
    ...mapGetters({
      loadingStatus: "chartOfAccountModule/loadingStatus",
      chartOfAccounts: "chartOfAccountModule/chartOfAccounts",
      filterCriteria: "chartOfAccountModule/filterCriteria",
      selectedFilter: "chartOfAccountModule/selectedFilter",
      selectedPreFilters: "chartOfAccountModule/selectedPreFilters",
    }),
  },
  methods: {
    ...mapActions({
      getChartOfAccounts: "chartOfAccountModule/getChartOfAccounts",
      setSelectedFilter: "chartOfAccountModule/setSelectedFilter",
    }),
    loadData: function (filter) {
      this.setSelectedFilter(filter);
      this.getChartOfAccounts();
    },
    performSetSelectedFilter({ filter, filter2 }) {
      this.setSelectedFilter(filter);
      this.getChartOfAccounts();
    },
    emitSelectedElement(selectedElement) {
      this.$emit("elementSelected", selectedElement);
    },
  },
};
</script>

<style lang="scss"></style>
